import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { Grid, Typography, OutlinedInput } from '@material-ui/core'
import { List } from 'immutable'
import { useDispatch } from 'react-redux'

import Modal from '_components/modal'
import Select from '_components/select'
import Button from '_components/button'
import { cancelServiceOrder } from '_modules/service-orders/actions'
import { getHistoryLogs } from '_modules/history-logs/actions'

import useStyles from './styles'
import { ConfidentialDataWarning } from '_/components/ConfidentialDataWarning'
import { useToast } from '_/hooks/use-toast'

const CancelModal = ({
  serviceOrderId,
  handleModal,
  cancelReasons,
  handleGetServiceOrderActive,
}) => {
  const styles = useStyles()
  const [reason, setReason] = useState('')
  const [serviceOrderCancelDetails, setServiceOrderCancelDetails] = useState('')
  const [enabledConfirmButton, setEnableConfirmButton] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useDispatch()
  const { showToast } = useToast()

  const onSelect = useCallback(event => {
    const { value } = event.target
    setReason(value)
    setEnableConfirmButton(true)
  }, [])

  const handleInputChange = useCallback(event => {
    const { value } = event.target
    setServiceOrderCancelDetails(value)
  })

  const handleCancelServiceOrder = useCallback(() => {
    setIsLoading(true)
    dispatch(cancelServiceOrder(reason, serviceOrderCancelDetails))
      .then(() => {
        dispatch(getHistoryLogs(serviceOrderId))
        handleGetServiceOrderActive()
        handleModal()
      })
      .catch(err => {
        let message = 'Ocorreu um erro ao cancelar o chamado.'

        if (err?.message && err?.message?.includes('Erro ao atualizar etapa do chamado.')) {
          message =
            'O chamado está em uma etapa que não permite cancelar com esse motivo de cancelamento.'
        } else if (err?.message) {
          message = err?.message
        }

        showToast({
          type: 'error',
          message,
        })
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [dispatch, reason, serviceOrderCancelDetails])

  return (
    <Modal
      title={`Cancelar chamado ID #${serviceOrderId}`}
      handleModal={handleModal}
      hideActionButtons
    >
      <Grid className={styles.container}>
        <Select
          label="Selecione o motivo do cancelamento"
          options={cancelReasons?.toArray()}
          value={reason}
          onChange={onSelect}
        />
        <Typography className={styles.textTitle}>Mais detalhes do cancelamento</Typography>
        <OutlinedInput
          multiline
          className={styles.textInput}
          inputProps={{ maxLength: 1000 }}
          placeholder="Mais detalhes"
          name="serviceOrderCancelDetails"
          value={serviceOrderCancelDetails}
          onChange={handleInputChange}
        />
        <ConfidentialDataWarning style={{ marginBottom: -16 }} />
        <Button className={styles.button} fullWidth onClick={handleModal} disabled={isLoading}>
          Desfazer e manter chamado
        </Button>
        <Button
          isLoading={isLoading}
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleCancelServiceOrder}
          disabled={!enabledConfirmButton}
        >
          Confirmar e cancelar chamado
        </Button>
      </Grid>
    </Modal>
  )
}

CancelModal.propTypes = {
  serviceOrderId: PropTypes.string.isRequired,
  handleModal: PropTypes.func.isRequired,
  cancelReasons: PropTypes.instanceOf(List).isRequired,
}

export default React.memo(CancelModal)
